import RegisterPage from "./Security/Register/RegisterPage";
import LoginPage from "./Security/Login/LoginPage";
import ProfilePage from "./Security/Profile/ProfilePage";
import HomePage from "./Home/HomePage";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import PrivateRouter from "./Router/PrivateRouter";
import InternalServer from "./_components/ErrorPages/InternalServer/InternalServer";
import NotFound from "./_components/ErrorPages/NotFound/NotFound";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { getCurrentUser } from "./_store/_actions/repositoryUserActions";
import Wallet from "./_components/Wallet/Wallet";
import MembershipPage from "./Security/Membership/MembershipPage";
import ReactLoading from "react-loading";
//import './App.css';
import TravelYourWay from "./_components/TravelYourWay/TravelYourWay";
import ATADashboard from "./_components/ATADashboard/ATADashboard";
import HowWorks from "./_components/HowWorks/HowWorks";
import ReefResorts from "./_components/ReefResorts/ReefResorts";

function App() {
  const dispatch = useDispatch();
  const [initApp, setInitApp] = useState(false);
  const { loading } = useSelector((state) => state.ui || false);

  useEffect(() => {
    if (!initApp) {
      dispatch(getCurrentUser())
        .then((response) => {
          setInitApp(true);
          if (response.status === 200) {
            return <Redirect to="/" />;
          }
        })
        .catch((error) => {
          setInitApp(true);
        });
    }
  }, [initApp, dispatch]);

  if (!initApp) {
    return (
      <ReactLoading
        className="loading-time"
        type="spin"
        color="#143899"
        height={"80px"}
        width={"80px"}
      />
    );
  }

  return (
    <div className="stretched">
      {loading && (
        <ReactLoading
          className="loading-time"
          type="spin"
          color="#143899"
          height={"80px"}
          width={"80px"}
        />
      )}

      <Router basename="/thereef/wallet">
        <HomePage>
          <Switch>
            <PrivateRouter exact path="/" component={Wallet} />
            <PrivateRouter exact path="/profile" component={ProfilePage} />
            <PrivateRouter exact path="/travel" component={TravelYourWay} />

            <PrivateRouter
              exact
              path="/membership"
              component={MembershipPage}
            />
            <PrivateRouter exact path="/howworks" component={HowWorks} />
            <PrivateRouter exact path="/reefresorts" component={ReefResorts} />

            <Route exact path="/login" component={LoginPage} />
            <Route exact path="/register" component={RegisterPage} />
            <Route exact path="/500" component={InternalServer} />
            <Route exact path="/404" component={NotFound} />

            <Redirect to="/login" component={LoginPage} />
          </Switch>
        </HomePage>
      </Router>
    </div>
  );
}

export default App;
